export default function Differentiators() {
  const differentiators = [
    {
      title: 'Strategy-Led Implementation',
      description: 'Every system begins with operational analysis and strategic design before any automation is deployed.'
    },
    {
      title: 'Industry-Focused Systems',
      description: 'Solutions built specifically for the operational realities of regulated and service-driven businesses.'
    },
    {
      title: 'Measurable Operational Outcomes',
      description: 'Clear metrics and performance dashboards that track real business impact and efficiency gains.'
    },
    {
      title: 'Scalable Infrastructure',
      description: 'Systems designed to grow with your organization, from initial implementation to enterprise scale.'
    }
  ];

  return (
    <section className="py-32 px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-5xl md:text-6xl font-light text-[#0E1A2B] mb-20 text-center tracking-tight">
          What Makes Us Different
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {differentiators.map((item, index) => (
            <div
              key={index}
              className="p-12 bg-white border border-[#D9DEE5] rounded-2xl hover:border-[#2F6BFF] transition-all duration-300"
            >
              <h3 className="text-2xl font-medium text-[#0E1A2B] mb-4 tracking-tight">
                {item.title}
              </h3>
              <p className="text-lg font-light text-[#5C6675] leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}